import { hisHttpClient } from '@/lib/api/his-client'
import { HisPatient } from '../types/patient'

export const hisApi = {
  getPatientByHn: async (vn: string) => {
    try {
      const res = await hisHttpClient.get<HisPatient>('api/his/getpatientbyvn', {
        params: { vn },
      })
      return res.data
    } catch (error: any) {
      console.error('HIS error:', error?.message)
      return null
    }
  },
}
